import createIcon from "components/elements/Icons/create-icon";

export default createIcon(
  "Check",
  [
    [
      "path",
      {
        d: "M7.97978 18.2918L8.33333 18.6453L8.68688 18.2918L21.2671 5.71153L20.9135 5.35798L21.2671 5.71153C21.5491 5.42949 22.0064 5.42949 22.2884 5.71153C22.5705 5.99358 22.5705 6.45087 22.2884 6.73291L8.84402 20.1773C8.56198 20.4594 8.10469 20.4594 7.82264 20.1773L1.71153 14.0662L1.35798 14.4198L1.71153 14.0662C1.42949 13.7842 1.42949 13.3269 1.71153 13.0449C1.99358 12.7628 2.45087 12.7628 2.73291 13.0449L7.97978 18.2918Z",
      },
    ],
  ],
  "currentColor"
);
